import { Button } from "@/components/ui/button";
import { ArrowRight, CalendarClock, CheckCircle2, Clock } from "lucide-react";

export function NextStepCard({ next, onGo }) {
  const waiting = next.key === "waiting" || next.key === "done";
  const Icon = next.key === "done" ? CheckCircle2 : waiting ? Clock : ArrowRight;
  return (
    <section className="mt-6 rounded-3xl bg-slate-900 text-white p-5 sm:p-8 shadow-xl" data-testid="dashboard-next-step">
      <div className="text-[11px] uppercase tracking-[0.22em] text-purple-300 font-semibold">Your next step</div>
      <h2 className="mt-2 text-2xl sm:text-3xl font-semibold leading-tight !text-white" data-testid="dashboard-next-step-title">{next.title}</h2>
      <p className="mt-2 text-sm sm:text-base text-slate-300 max-w-2xl">{next.body}</p>
      {next.due && (
        <div className="mt-3 inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1.5 text-xs text-slate-100" data-testid="dashboard-next-step-due">
          <CalendarClock size={14} />Response window ends around {new Date(next.due).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" })}
        </div>
      )}
      <div>
      <Button
        onClick={() => onGo(next.to)}
        className={`mt-5 w-full sm:w-auto min-h-[52px] h-auto whitespace-normal text-center rounded-2xl px-5 py-3 text-base font-semibold transition-transform hover:-translate-y-0.5 ${waiting ? "bg-white text-slate-900 hover:bg-slate-100" : "bg-purple-500 hover:bg-purple-400 text-white"}`}
        data-testid="dashboard-next-step-cta"
      >
        {next.cta}<Icon size={18} className="ml-2" />
      </Button>
      </div>
    </section>
  );
}
